export interface ApiResponse<T = unknown> {
  success: boolean
  message: string
  /** Only the steps that need to read something back populate this. */
  data?: T
}

// Always resolves, so a caller can never be left with a spinner running
// forever after a network blip or a non-JSON error page.
export async function postJson<T = unknown>(path: string, body: unknown): Promise<ApiResponse<T>> {
  try {
    const res = await fetch(`${process.env.REACT_APP_API_URL}${path}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    })

    const json = await res.json()

    return {
      success: !!json.success,
      message: String(json.message ?? ""),
      data: json.data as T | undefined,
    }
  } catch {
    return { success: false, message: "Something went wrong. Please try again." }
  }
}
